import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'

function AttendanceStatusSelect({ value, onChange, onClick }) {
  return (
    <FormControl fullWidth>
      <InputLabel>Status</InputLabel>
      <Select
        value={value || ''}
        onChange={onChange}
        onClick={onClick}
        label="Status"
      >
        <MenuItem value="Present">Present</MenuItem>
        <MenuItem value="Absent">Absent</MenuItem>
        <MenuItem value="Excused Absence">Excused Absence</MenuItem>
        <MenuItem value="Late">Late</MenuItem>
      </Select>
    </FormControl>
  )
}

export default AttendanceStatusSelect
